import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "ÄŒudna polka",
  "description": "",
  "published": "2007-04-05T00:00:00.000Z",
  "redirect_from": ["/blog/udna-polka/swizec/240"],
  "categories": "video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ne vem kaj je narobe z Weird Alom ampak nekako ne odneha s polkaziranjem dobre glasbe. Video prikazuje eno njegovih polk popolno sinhronizirano z originali katerih besedila je pokradel in priredil. Stvar vam preprosto mora biti všeÄ, ni druge izbire.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      